export default "__VITE_ASSET__DIfQXJkX__"